const moduleNameKey = "multiLine";

export const multiLineEn = {
  [moduleNameKey]: {
    saveButton: "Save",
    cancelButton: "Cancel",
    titleLabel: "Chart Title",
    titleInputPlaceholder: "Enter chart title",
    machineLabel: "Machine",
    noMachines: "No machines found",
    machinesPlaceholder: "Search machines...",
    nodeLabel: "Node",
    noNodes: "No nodes found",
    nodesPlaceholder: "Search nodes...",
    unitLabel: "Unit",
    noUnits: "No units found",
    unitsPlaceholder: "Search units...",
    multiLineSeriesLabel: "Series",
    addLine: "Add node to chart",
    removeLineAlt: "Remove line",
    colorLabel: "Chart color",
    frequencyLabel: "Frequency",
    noFrequencies: "No frequencies found",
    granularityPlaceholder: "Select granularity",
    timeRangeLabel: "Time range",
    lookbackLabel: "Lookback",
    timeframeLabel: "Timeframe",
    startLabel: "Start",
    endLabel: "End",
    noLookbacks: "No lookback options found",
    lookbackPlaceholder: "Select lookback",
    pollingIntervalLabel: "Polling interval",
    pollingInfoText: "Polling follows the aggregation frequency",
    thresholdLabel: "Threshold",
    warningLabel: "Warning",
    criticalLabel: "Critical",
    aggregateBoundsLabel: "Aggregated bounds",
    showMinLabel: "Show min",
    showMaxLabel: "Show max",
    manualYRangeLabel: "Set Y-Axis range manually",
    yMinLabel: "Y min",
    yMaxLabel: "Y max",
    resetYRangeLabel: "Reset",
    titleRequired: "Title is required",
    timeframeRequired: "Pick a start and end date",
    durationRequired: "Pick a duration",
    frequencyRequired: "Frequency is required",
    lineFieldsEmpty: "Fill the empty fields or remove them",
    yAxisBoundsRequired:
      "Enter both Y min and Y max, or turn off manual Y range.",
    yAxisRangeInvalid: "Y min must be less than Y max",
    warningValueRequired: "Warning value is required",
    criticalValueRequired: "Critical value is required",
    thresholdOrderInvalid: "Critical cannot be lower than Warning",
    scaleInvalid: "Scaling factor must be a number",
  },
};

export const multiLinePtBr = {
  [moduleNameKey]: {
    saveButton: "Salvar",
    cancelButton: "Cancelar",
    titleLabel: "Título do Gráfico",
    titleInputPlaceholder: "Digite o título do gráfico",
    machineLabel: "Máquina",
    noMachines: "Nenhuma máquina encontrada",
    machinesPlaceholder: "Buscar máquinas...",
    nodeLabel: "Nó",
    noNodes: "Nenhum nó encontrado",
    nodesPlaceholder: "Buscar nós...",
    unitLabel: "Unidade",
    noUnits: "Nenhuma unidade encontrada",
    unitsPlaceholder: "Buscar unidades...",
    multiLineSeriesLabel: "Séries",
    addLine: "Adicionar nó ao gráfico",
    removeLineAlt: "Remover linha",
    colorLabel: "Cor do gráfico",
    frequencyLabel: "Frequência",
    noFrequencies: "Nenhuma frequência encontrada",
    granularityPlaceholder: "Selecione a granularidade",
    timeRangeLabel: "Intervalo de tempo",
    lookbackLabel: "Janela de leitura",
    timeframeLabel: "Período",
    startLabel: "Início",
    endLabel: "Fim",
    noLookbacks: "Nenhuma janela de leitura encontrada",
    lookbackPlaceholder: "Selecione a janela",
    pollingIntervalLabel: "Intervalo de atualização",
    pollingInfoText: "A atualização segue a frequência de agregação",
    thresholdLabel: "Limiar",
    warningLabel: "Aviso",
    criticalLabel: "Crítico",
    aggregateBoundsLabel: "Limites agregados",
    showMinLabel: "Mostrar mínimo",
    showMaxLabel: "Mostrar máximo",
    manualYRangeLabel: "Definir intervalo do eixo Y manualmente",
    yMinLabel: "Y mín",
    yMaxLabel: "Y máx",
    resetYRangeLabel: "Redefinir",
    titleRequired: "Título é obrigatório",
    timeframeRequired: "Selecione uma data inicial e final",
    durationRequired: "Selecione uma duração",
    frequencyRequired: "Frequência é obrigatória",
    lineFieldsEmpty: "Preencha os campos vazios ou remova-os",
    yAxisBoundsRequired:
      "Informe Y mín e Y máx, ou desative o intervalo Y manual.",
    yAxisRangeInvalid: "Y mín deve ser menor que Y máx",
    warningValueRequired: "Valor de aviso é obrigatório",
    criticalValueRequired: "Valor crítico é obrigatório",
    thresholdOrderInvalid: "Crítico não pode ser menor que Aviso",
    scaleInvalid: "O fator de escala deve ser um número",
  },
};

export const multiLineDe = {
  [moduleNameKey]: {
    saveButton: "Speichern",
    cancelButton: "Abbrechen",
    titleLabel: "Titel des Diagramms",
    titleInputPlaceholder: "Titel des Diagramms eingeben",
    machineLabel: "Maschine",
    noMachines: "Keine Maschinen gefunden",
    machinesPlaceholder: "Maschinen suchen...",
    nodeLabel: "Knoten",
    noNodes: "Keine Knoten gefunden",
    nodesPlaceholder: "Knoten suchen...",
    unitLabel: "Einheit",
    noUnits: "Keine Einheiten gefunden",
    unitsPlaceholder: "Einheiten suchen...",
    multiLineSeriesLabel: "Reihen",
    addLine: "Knoten zum Diagramm hinzufügen",
    removeLineAlt: "Linie entfernen",
    colorLabel: "Diagrammfarbe",
    frequencyLabel: "Frequenz",
    noFrequencies: "Keine Frequenzen gefunden",
    granularityPlaceholder: "Granularität wählen",
    timeRangeLabel: "Zeitspanne",
    lookbackLabel: "Rückblick",
    timeframeLabel: "Zeitraum",
    startLabel: "Start",
    endLabel: "Ende",
    noLookbacks: "Keine Rückblicke gefunden",
    lookbackPlaceholder: "Rückblick wählen",
    pollingIntervalLabel: "Aktualisierungsintervall",
    pollingInfoText: "Die Aktualisierung folgt der Aggregationsfrequenz",
    thresholdLabel: "Schwelle",
    warningLabel: "Warnung",
    criticalLabel: "Kritisch",
    aggregateBoundsLabel: "Aggregierte Grenzen",
    showMinLabel: "Minimum anzeigen",
    showMaxLabel: "Maximum anzeigen",
    manualYRangeLabel: "Y-Achsenbereich manuell festlegen",
    yMinLabel: "Y min",
    yMaxLabel: "Y max",
    resetYRangeLabel: "Zurücksetzen",
    titleRequired: "Titel ist erforderlich",
    timeframeRequired: "Start- und Enddatum auswählen",
    durationRequired: "Dauer auswählen",
    frequencyRequired: "Frequenz ist erforderlich",
    lineFieldsEmpty:
      "Bitte füllen Sie die leeren Felder aus oder entfernen Sie sie",
    yAxisBoundsRequired:
      "Y min und Y max eingeben oder den manuellen Y-Bereich ausschalten.",
    yAxisRangeInvalid: "Y min muss kleiner als Y max sein",
    warningValueRequired: "Warnwert ist erforderlich",
    criticalValueRequired: "Kritischer Wert ist erforderlich",
    thresholdOrderInvalid: "Kritisch darf nicht kleiner als Warnung sein",
    scaleInvalid: "Der Skalierungsfaktor muss eine Zahl sein",
  },
};

export const multiLineZhHans = {
  [moduleNameKey]: {
    saveButton: "保存",
    cancelButton: "取消",
    titleLabel: "图表标题",
    titleInputPlaceholder: "输入图表标题",
    machineLabel: "机器",
    noMachines: "未找到机器",
    machinesPlaceholder: "搜索机器...",
    nodeLabel: "节点",
    noNodes: "未找到节点",
    nodesPlaceholder: "搜索节点...",
    unitLabel: "单位",
    noUnits: "未找到单位",
    unitsPlaceholder: "搜索单位...",
    multiLineSeriesLabel: "序列",
    addLine: "添加节点到图表",
    removeLineAlt: "删除线",
    colorLabel: "图表颜色",
    frequencyLabel: "频率",
    noFrequencies: "未找到频率",
    granularityPlaceholder: "选择粒度",
    timeRangeLabel: "时间范围",
    lookbackLabel: "回溯时间",
    timeframeLabel: "时间段",
    startLabel: "开始",
    endLabel: "结束",
    noLookbacks: "未找到回溯时间",
    lookbackPlaceholder: "选择回溯时间",
    pollingIntervalLabel: "轮询间隔",
    pollingInfoText: "轮询频率与聚合频率一致",
    thresholdLabel: "阈值",
    warningLabel: "警告",
    criticalLabel: "严重",
    aggregateBoundsLabel: "聚合边界",
    showMinLabel: "显示最小值",
    showMaxLabel: "显示最大值",
    manualYRangeLabel: "手动设置 Y 轴范围",
    yMinLabel: "Y 最小值",
    yMaxLabel: "Y 最大值",
    resetYRangeLabel: "重置",
    titleRequired: "标题是必填项",
    timeframeRequired: "选择开始和结束日期",
    durationRequired: "选择持续时间",
    frequencyRequired: "频率是必填项",
    lineFieldsEmpty: "请填写或删除空字段",
    yAxisBoundsRequired: "请填写 Y 最小值和 Y 最大值，或关闭手动 Y 轴范围。",
    yAxisRangeInvalid: "Y 最小值必须小于 Y 最大值",
    warningValueRequired: "警告值是必填项",
    criticalValueRequired: "严重值是必填项",
    thresholdOrderInvalid: "严重值不能低于警告值",
    scaleInvalid: "缩放系数必须为数字",
  },
};

export const multiLineIt = {
  [moduleNameKey]: {
    saveButton: "Salva",
    cancelButton: "Annulla",
    titleLabel: "Titolo del Grafico",
    titleInputPlaceholder: "Inserisci il titolo del grafico",
    machineLabel: "Macchina",
    noMachines: "Nessuna macchina trovata",
    machinesPlaceholder: "Cerca macchine...",
    nodeLabel: "Nodo",
    noNodes: "Nessun nodo trovato",
    nodesPlaceholder: "Cerca nodi...",
    unitLabel: "Unità",
    noUnits: "Nessuna unità trovata",
    unitsPlaceholder: "Cerca unità...",
    multiLineSeriesLabel: "Serie",
    addLine: "Aggiungi nodo al grafico",
    removeLineAlt: "Rimuovi linea",
    colorLabel: "Colore grafico",
    frequencyLabel: "Frequenza",
    noFrequencies: "Nessuna frequenza trovata",
    granularityPlaceholder: "Seleziona granularità",
    timeRangeLabel: "Intervallo di tempo",
    lookbackLabel: "Periodo di osservazione",
    timeframeLabel: "Periodo",
    startLabel: "Inizio",
    endLabel: "Fine",
    noLookbacks: "Nessun periodo di osservazione trovato",
    lookbackPlaceholder: "Seleziona periodo",
    pollingIntervalLabel: "Intervallo di aggiornamento",
    pollingInfoText: "L'aggiornamento segue la frequenza di aggregazione",
    thresholdLabel: "Soglia",
    warningLabel: "Avviso",
    criticalLabel: "Critica",
    aggregateBoundsLabel: "Limiti aggregati",
    showMinLabel: "Mostra minimo",
    showMaxLabel: "Mostra massimo",
    manualYRangeLabel: "Imposta intervallo Y manualmente",
    yMinLabel: "Y min",
    yMaxLabel: "Y max",
    resetYRangeLabel: "Ripristina",
    titleRequired: "Il titolo è obbligatorio",
    timeframeRequired: "Seleziona una data di inizio e fine",
    durationRequired: "Seleziona una durata",
    frequencyRequired: "La frequenza è obbligatoria",
    lineFieldsEmpty: "Compila i campi vuoti o rimuovili",
    yAxisBoundsRequired:
      "Inserisci Y min e Y max oppure disattiva l'intervallo Y manuale.",
    yAxisRangeInvalid: "Y min deve essere minore di Y max",
    warningValueRequired: "Il valore di avviso è obbligatorio",
    criticalValueRequired: "Il valore critico è obbligatorio",
    thresholdOrderInvalid: "Critico non può essere inferiore ad Allarme",
    scaleInvalid: "Il fattore di scala deve essere un numero",
  },
};

export const multiLineEs = {
  [moduleNameKey]: {
    saveButton: "Guardar",
    cancelButton: "Cancelar",
    titleLabel: "Título del Gráfico",
    titleInputPlaceholder: "Ingrese el título del gráfico",
    machineLabel: "Máquina",
    noMachines: "No se encontraron máquinas",
    machinesPlaceholder: "Buscar máquinas...",
    nodeLabel: "Nodo",
    noNodes: "No se encontraron nodos",
    nodesPlaceholder: "Buscar nodos...",
    unitLabel: "Unidad",
    noUnits: "No se encontraron unidades",
    unitsPlaceholder: "Buscar unidades...",
    multiLineSeriesLabel: "Series",
    addLine: "Agregar nodo al gráfico",
    removeLineAlt: "Eliminar línea",
    colorLabel: "Color del gráfico",
    frequencyLabel: "Frecuencia",
    noFrequencies: "No se encontraron frecuencias",
    granularityPlaceholder: "Seleccionar granularidad",
    timeRangeLabel: "Período de tiempo",
    lookbackLabel: "Periodo de búsqueda",
    timeframeLabel: "Período",
    startLabel: "Desde",
    endLabel: "Hasta",
    noLookbacks: "No se encontraron periodos de búsqueda",
    lookbackPlaceholder: "Selecciona el periodo",
    pollingIntervalLabel: "Intervalo de actualización",
    pollingInfoText: "La actualización sigue la frecuencia de agregación",
    thresholdLabel: "Umbral",
    warningLabel: "Advertencia",
    criticalLabel: "Crítico",
    aggregateBoundsLabel: "Límites agregados",
    showMinLabel: "Mostrar mínimo",
    showMaxLabel: "Mostrar máximo",
    manualYRangeLabel: "Establecer rango del eje Y manualmente",
    yMinLabel: "Y mín",
    yMaxLabel: "Y máx",
    resetYRangeLabel: "Restablecer",
    titleRequired: "El título es obligatorio",
    timeframeRequired: "Seleccione una fecha de inicio y fin",
    durationRequired: "Seleccione una duración",
    frequencyRequired: "La frecuencia es obligatoria",
    lineFieldsEmpty: "Complete o elimine los campos vacíos",
    yAxisBoundsRequired:
      "Introduce Y mín e Y máx, o desactiva el rango Y manual.",
    yAxisRangeInvalid: "Y mín debe ser menor que Y máx",
    warningValueRequired: "El valor de advertencia es obligatorio",
    criticalValueRequired: "El valor crítico es obligatorio",
    thresholdOrderInvalid: "Crítico no puede ser menor que Advertencia",
    scaleInvalid: "El factor de escala debe ser un número",
  },
};

export const multiLineNl = {
  [moduleNameKey]: {
    saveButton: "Opslaan",
    cancelButton: "Annuleren",
    titleLabel: "Grafiektitel",
    titleInputPlaceholder: "Typ de grafiektitel",
    machineLabel: "Machine",
    noMachines: "Geen machines gevonden",
    machinesPlaceholder: "Machines zoeken...",
    nodeLabel: "Knooppunt",
    noNodes: "Geen knooppunten gevonden",
    nodesPlaceholder: "Knooppunten zoeken...",
    unitLabel: "Eenheid",
    noUnits: "Geen eenheden gevonden",
    unitsPlaceholder: "Eenheden",
    multiLineSeriesLabel: "Reeksen",
    addLine: "Knooppunt aan grafiek toevoegen",
    removeLineAlt: "Lijn verwijderen",
    colorLabel: "Grafiekkleur",
    frequencyLabel: "Frequentie",
    noFrequencies: "Geen frequenties gevonden",
    granularityPlaceholder: "Kies granulariteit",
    timeRangeLabel: "Tijdsbereik",
    lookbackLabel: "Terugkijkperiode",
    timeframeLabel: "Tijdsbestek",
    startLabel: "Start",
    endLabel: "Eind",
    noLookbacks: "Geen terugkijkperiodes gevonden",
    lookbackPlaceholder: "Selecteer een terugkijkperiode",
    pollingIntervalLabel: "Polling-interval",
    pollingInfoText: "Polling volgt de aggregatiefrequentie",
    thresholdLabel: "Drempel",
    warningLabel: "Waarschuwing",
    criticalLabel: "Kritiek",
    aggregateBoundsLabel: "Geaggregeerde grenzen",
    showMinLabel: "Minimumwaarde weergeven",
    showMaxLabel: "Maximumwaarde weergeven",
    manualYRangeLabel: "Stel Y-as bereik handmatig in",
    yMinLabel: "Y min",
    yMaxLabel: "Y max",
    resetYRangeLabel: "Resetten",
    titleRequired: "Titel is vereist",
    timeframeRequired: "Tijdsbestek is vereist",
    durationRequired: "Kies een duur",
    frequencyRequired: "Frequentie is vereist",
    lineFieldsEmpty: "Vul lege velden in of verwijder ze",
    yAxisBoundsRequired:
      "Vul zowel Y min als Y max in, of schakel het handmatige Y-bereik uit.",
    yAxisRangeInvalid: "Y min moet kleiner zijn dan Y max",
    warningValueRequired: "Waarschuwingswaarde is vereist",
    criticalValueRequired: "Kritieke waarde is vereist",
    thresholdOrderInvalid:
      "Onderste drempelwaarde moet kleiner zijn dan bovenste drempelwaarde",
    scaleInvalid: "De schaalfactor moet een getal zijn",
  },
};

export const multiLineTr = {
  [moduleNameKey]: {
    saveButton: "Kaydetmek",
    cancelButton: "İptal etmek",
    titleLabel: "Grafik Başlığı",
    titleInputPlaceholder: "Grafik başlığını girin",
    machineLabel: "Makine",
    noMachines: "Hiçbir makine bulunamadı",
    machinesPlaceholder: "Arama makineleri...",
    nodeLabel: "Düğüm",
    noNodes: "Hiçbir düğüm bulunamadı",
    nodesPlaceholder: "Düğümleri ara...",
    unitLabel: "Birim",
    noUnits: "Birim bulunamadı",
    unitsPlaceholder: "Birimleri arayın...",
    multiLineSeriesLabel: "Seri",
    addLine: "Grafiğe düğüm ekle",
    removeLineAlt: "Satırı kaldır",
    colorLabel: "Grafik rengi",
    frequencyLabel: "Sıklık",
    noFrequencies: "Hiçbir sıklık bulunamadı",
    granularityPlaceholder: "Ayrıntı düzeyini seçin",
    timeRangeLabel: "Zaman aralığı",
    lookbackLabel: "Geriye bakma",
    timeframeLabel: "Zaman aralığı",
    startLabel: "Başlangıç",
    endLabel: "Son",
    noLookbacks: "Hiçbir geriye bakma bulunamadı",
    lookbackPlaceholder: "Yeniden incelemeyi seçin",
    pollingIntervalLabel: "Yoklama aralığı",
    pollingInfoText: "Oylama, toplama sıklığını takip eder",
    thresholdLabel: "Eşik",
    warningLabel: "Uyarı",
    criticalLabel: "Kritik",
    aggregateBoundsLabel: "Toplu sınırlar",
    showMinLabel: "Dakikayı göster",
    showMaxLabel: "Maksimum göster",
    manualYRangeLabel: "Y ekseni aralığını manuel olarak ayarla",
    yMinLabel: "Y min",
    yMaxLabel: "Y max",
    resetYRangeLabel: "Sıfırla",
    titleRequired: "Başlık gerekli",
    timeframeRequired: "Bir başlangıç ve bitiş tarihi seçin",
    durationRequired: "Bir süre seçin",
    frequencyRequired: "Sıklık gerekli",
    lineFieldsEmpty: "Boş alanları doldurun veya kaldırın",
    yAxisBoundsRequired:
      "Y min ve Y max değerlerini girin veya manuel Y aralığını kapatın.",
    yAxisRangeInvalid: "Y min, Y max'ten küçük olmalıdır",
    warningValueRequired: "Uyarı değeri gerekli",
    criticalValueRequired: "Kritik değer gerekli",
    thresholdOrderInvalid: "Kritik Uyarı'dan düşük olamaz",
    scaleInvalid: "Ölçek faktörü bir sayı olmalıdır",
  },
};
